var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .75A7.749 7.749 0 0 0 .25 8.5 7.749 7.749 0 0 0 8 16.25a7.749 7.749 0 0 0 7.75-7.75A7.749 7.749 0 0 0 8 .75Zm2.875 9.781-.625.781a.488.488 0 0 1-.406.22.465.465 0 0 1-.281-.126L7.469 9.844C7.156 9.625 7 9.28 7 8.875V4c0-.25.219-.5.5-.5h1c.25 0 .5.25.5.5v4.5l1.813 1.344c.093.094.187.219.187.375 0 .125-.063.25-.125.312Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.9a154f3478ac41c957d713af610f5ec9.svg";
export { ForwardRef as ReactComponent };